interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

const MessageIcon = ({ width = '40', height = '40', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.1" y="0.1" width="39.8" height="39.8" rx="19.9" fill="white" />
                <rect x="0.1" y="0.1" width="39.8" height="39.8" rx="19.9" stroke="white" strokeWidth="0.2" />
                <path
                    d="M16.5 27H16C12 27 10 26 10 21V16C10 12 12 10 16 10H24C28 10 30 12 30 16V21C30 25 28 27 24 27H23.5C23.19 27 22.89 27.15 22.7 27.4L21.2 29.4C20.54 30.28 19.46 30.28 18.8 29.4L17.3 27.4C17.14 27.18 16.77 27 16.5 27Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.9965 19H24.0054"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.9955 19H20.0045"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.9945 19H16.0035"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default MessageIcon;
